import React, { useState } from "react";
import { Box, Checkbox, Typography } from "@mui/material";
import { Check } from "@mui/icons-material";
import { theme } from "../../Assets/Theme/theme";

const CustomCheckboxLabel = ({
  label,
  fontSize,
  marginBottom,
  value,
  onChange,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        marginBottom: marginBottom,
      }}
    >
      <Checkbox
        checked={value}
        onChange={onChange}
        icon={
          <Box
            sx={{
              width: 34,
              height: 34,
              border: `2px solid ${theme.colors.orange}`,
              borderRadius: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        }
        checkedIcon={
          <Box
            sx={{
              width: 20,
              height: 20,
              backgroundColor: theme.colors.orange,
              borderRadius: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Check sx={{ color: "#fff", fontSize: 16 }} />
          </Box>
        }
        sx={{
          padding: 0,
          marginRight: 1,
        }}
      />
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: fontSize,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default CustomCheckboxLabel;
